import { render, staticRenderFns } from "./build_health_home2_dashboard.vue?vue&type=template&id=a6c87848&scoped=true"
import script from "./build_health_home2_dashboard.vue?vue&type=script&lang=js"
export * from "./build_health_home2_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_health_home2_dashboard.vue?vue&type=style&index=0&id=a6c87848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c87848",
  null
  
)

export default component.exports